{
  "_format": "hh-sol-artifact-1",
  "contractName": "MainContract",
  "sourceName": "src/backend/contracts/Main.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "previousAdmin",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newAdmin",
          "type": "address"
        }
      ],
      "name": "AdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "beacon",
          "type": "address"
        }
      ],
      "name": "BeaconUpgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "acceptBet",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractClan",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractCollection",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractInventory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractLandNFT",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractLandNFTHelper",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractMarket",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractModifier",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractMonsterNFT",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractMonsterNFTHelper",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractPay",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractTokenFT",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractZombieNFT",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getContractZombieNFTHelper",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "_accounts",
          "type": "address[]"
        },
        {
          "internalType": "uint256[]",
          "name": "_amounts",
          "type": "uint256[]"
        }
      ],
      "name": "releaseWinnerBets",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_token",
          "type": "address"
        }
      ],
      "name": "setPaymentToken",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "transferOnKill",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "transferRewards",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_landNFT",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_zombieNFT",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_monsterNFT",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_tokenFT",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_collection",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_market",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_clan",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_tokenPay",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_inventory",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_modifier",
          "type": "address"
        }
      ],
      "name": "updateContractAddress",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_landNFTHelper",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_zombieNFTHelper",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_monsterNFTHelper",
          "type": "address"
        }
      ],
      "name": "updateContractHelperAddress",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        }
      ],
      "name": "upgradeTo",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}